<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 *ngIf="currentUser.UserRoleId == 2" class="page-title">
                Edit Doctor
              </h4>
              <h4 *ngIf="currentUser.UserRoleId == 3" class="page-title">
                Edit Admin
              </h4>
              <h4 *ngIf="currentUser.UserRoleId == 4" class="page-title">
                Edit Pharmacist
              </h4>
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <!-- <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Doctors</a>
            </li>
            <li class="breadcrumb-item active">Edit</li>
            </li> -->
          </ul>
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 pb-2">
          <a
            (click)="goBack()"
            class="btn btn-group-lg btn-outline-secondary float-end"
          >
            <i class="fa fa-angle-left"></i> Back
          </a>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <!-- <div class="header">
            <h2 *ngIf="currentUser.UserRoleId == 2">Edit Doctor</h2>
          </div>
          <div class="header">
            <h2
              *ngIf="currentUser.UserRoleId == 3 || currentUser.UserRoleId == 4"
            >
              Edit Pharmacist
            </h2>
          </div> -->
          <div class="body">
            <form
              class="m-4"
              [formGroup]="docForm"
              (ngSubmit)="UpdateUserDetails()"
            >
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <div class="user-panel-registration">
                    <div class="image">
                      <img
                        *ngIf="userAccount.ProfilePictureId==0 && userAccount.UserRoleId == 2"
                        alt="User Image"
                        class="img-circle user-img-circle"
                        src="assets/images/user/dr.png"
                      />
                      <img
                        *ngIf="userAccount.ProfilePictureId==0 && (userAccount.UserRoleId == 1 || userAccount.UserRoleId == 3 || userAccount.UserRoleId == 4)"
                        src="{{'../assets/images/user/user-1.png'}}"
                        alt="User Image"
                        class="img-circle user-img-circle"
                      />
                      <app-profile-pic
                        *ngIf="userAccount?.ProfilePictureId!=0 && userAccount?.ProfilePictureId!=null"
                        [documentId]="userAccount?.ProfilePictureId"
                        [type]="'thumb'"
                      >
                      </app-profile-pic>

                      <!-- <img
                        #profilePic
                        class="img-circle user-img-circle"
                        [src]="imgSrc"
                        alt=""
                      /> -->
                    </div>
                  </div>
                  <mat-form-field class="example-full-width">
                    <ngx-mat-file-input
                      (change)="uploadProfile($event)"
                      formControlName="picture"
                      placeholder="Click here to upload profile picture"
                      accept=".png,.jpeg,.jpeg"
                    >
                    </ngx-mat-file-input>
                    <mat-icon matSuffix>cloud_upload</mat-icon>
                    <!-- <mat-error
                      *ngIf="
                        docForm.get('picture').hasError('required') ||
                        docForm.get('picture').touched
                      "
                    >
                      Please enter a valid email address
                    </mat-error> -->
                  </mat-form-field>
                </div>
                <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 mb-3">
                  <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-0">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <mat-label>First Name</mat-label>
                        <input
                          matInput
                          formControlName="firstname"
                          [maxLength]="15"
                          required
                        />
                        <mat-error
                          *ngIf="docForm.controls.firstname.errors?.required"
                        >
                          First Name is required
                        </mat-error>
                        <mat-error
                          *ngIf="docForm.controls.firstname.errors?.pattern"
                        >
                          First Name is invalid
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-0">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <mat-label>Last Name</mat-label>
                        <input
                          matInput
                          formControlName="lastname"
                          [maxLength]="15"
                          required
                        />
                        <mat-error
                          *ngIf="docForm.controls.lastname.errors?.required"
                        >
                          Last Name is required
                        </mat-error>
                        <mat-error
                          *ngIf="docForm.controls.lastname.errors?.pattern"
                        >
                          Last Name is invalid
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-0">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <mat-label>Email</mat-label>
                        <input
                          matInput
                          [readonly]="true"
                          formControlName="email"
                        />
                      </mat-form-field>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-0">
                      <mat-form-field
                        class="example-full-width"
                        appearance="outline"
                      >
                        <mat-label>Phone</mat-label>
                        <input
                          matInput
                          formControlName="phone"
                          [pattern]="constants.PHONE_REGEXP"
                          [appOnlyNumberDirective]="true"
                          required
                          disabled
                          [maxLength]="10"
                        />
                        <mat-error
                          *ngIf="docForm.controls.phone.errors?.required"
                        >
                          Phone is required
                        </mat-error>
                        <mat-error
                          *ngIf="docForm.controls.phone.errors?.pattern"
                        >
                          Phone is invalid
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Gender</mat-label>
                    <mat-select formControlName="gender">
                      <mat-option value="M"> Male </mat-option>
                      <mat-option value="F"> Female </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="docForm.get('gender').hasError('required')"
                    >
                      Gender is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Date Of Birth</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      formControlName="dob"
                      [max]="maxDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- <mat-error *ngIf="docForm.get('dob').hasError('required')">
                      Please select date
                    </mat-error>
                    <mat-error *ngIf="docForm.get('dob').invalid">
                      Date Of Birth is invalid
                    </mat-error> -->
                  </mat-form-field>
                </div>

                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Registration Number *</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="registrationnumber"
                      [required]="this.currentUser.UserRoleId !== 2"
                      [maxLength]="20"
                    />
                    <mat-error
                      *ngIf="
                        docForm.get('registrationnumber').hasError('required')
                      "
                    >
                      Registration number is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Qualification</mat-label>
                    <mat-select
                      matInput
                      formControlName="qualification"
                      multiple
                      required
                    >
                      <mat-option
                        *ngFor="let qualification of qualifications"
                        [value]="qualification"
                        >{{qualification.Name}}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="docForm.get('qualification').hasError('required')"
                    >
                      Qualification is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Specialization</mat-label>
                    <mat-select
                      matInput
                      formControlName="specialization"
                      multiple
                    >
                      <!-- <mat-option
                        *ngFor="let specialization of specializations"
                        [value]="specialization"
                        >{{specialization.Name}}</mat-option
                      > -->
                    </mat-select>
                    <mat-error
                      *ngIf="docForm.get('specialization').hasError('required')"
                    >
                      Specialization is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Practice Name</mat-label>
                    <input
                      matInput
                      formControlName="practicename"
                      [maxLength]="50"
                      required
                    />
                    <mat-error
                      *ngIf="docForm.get('practicename').hasError('required')"
                    >
                      Practice Name is required
                    </mat-error>
                    <mat-error
                      *ngIf="docForm.controls.practicename.errors?.pattern"
                    >
                      Practice Name is invalid
                    </mat-error>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Office Contact Name</mat-label>
                    <input
                      matInput
                      formControlName="officecontactname"
                      [maxLength]="50"
                    />
                    <!-- <mat-error
                      *ngIf="
                        docForm.get('officecontactname').hasError('required')
                      "
                    >
                      Office contact name is required
                    </mat-error> -->
                    <!-- <mat-error
                      *ngIf="docForm.controls.officecontactname.errors?.pattern"
                    >
                      Office contact Name is invalid
                    </mat-error> -->
                  </mat-form-field>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Address Line 1</mat-label>
                    <input
                      matInput
                      formControlName="addreslineone"
                      [maxLength]="80"
                    />
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error
                      *ngIf="
                        docForm.get('addreslineone').hasError('required') ||
                        docForm.get('addreslineone').touched
                      "
                    >
                      Please enter a valid address
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Address Line 2</mat-label>
                    <input
                      matInput
                      formControlName="addreslinetwo"
                      [type]="'text'"
                      [maxLength]="80"
                    />
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error
                      *ngIf="docForm.get('addreslinetwo').hasError('required')"
                    >
                      Address line two is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>City</mat-label>
                    <input
                      matInput
                      formControlName="city"
                      [type]="'text'"
                      [maxLength]="15"
                    />
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error *ngIf="docForm.get('city').hasError('required')">
                      City is required
                    </mat-error>
                    <mat-error *ngIf="docForm.get('city').hasError('pattern')">
                      City is invalid
                    </mat-error>
                    <mat-error
                      *ngIf="!docForm.get('city').hasError('minLength') && !docForm.get('city').hasError('pattern')"
                    >
                      City Name should be greater than or equal 2 characters
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>State</mat-label>
                    <mat-select matInput formControlName="state">
                      <mat-option
                        *ngFor="let state of stateList"
                        [value]="state.Name"
                        >{{state.Name}}</mat-option
                      >
                    </mat-select>
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error
                      *ngIf="docForm.get('state').hasError('required')"
                    >
                      State is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Zip</mat-label>
                    <input
                      matInput
                      formControlName="zip"
                      [type]="'text'"
                      [maxLength]="10"
                    />
                    <mat-icon matSuffix> zip</mat-icon>
                    <mat-error *ngIf="docForm.get('zip').hasError('required')">
                      Zip is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Country</mat-label>
                    <mat-select matInput formControlName="country">
                      <mat-option
                        *ngFor="let country of countryList"
                        [value]="country.Name"
                        >{{country.Name}}</mat-option
                      >
                    </mat-select>
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error
                      *ngIf="docForm.get('country').hasError('required')"
                    >
                      Country is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div
                  *ngIf="this.currentUser.UserRoleId == 2"
                  class="col-xl-8 col-lg-8 col-md-6 col-sm-8 mb-3"
                >
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label> About Me</mat-label>
                    <textarea
                      style="height: 16px !important;"
                      matInput
                      formControlName="aboutme"
                      [type]="'text'"
                      [maxLength]="200"
                    ></textarea>

                    <mat-error
                      *ngIf="docForm.get('aboutme').hasError('required')"
                    >
                      About me is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" *ngIf="this.currentUser.UserRoleId == 3 || this.currentUser.UserRoleId == 4"> 
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
                  <div id="add-tag-wrapper" class="example-full-width"></div>
                    <ng-select #text bindLabel="name" bindValue="name" formControlName="collectionlocation"
                      (keyup.enter)="enterCollectionLocation(text,false)" [items]="collectionLocation" [(ngModel)]="collectionLocation" [multiple]="true" 
                      (keypress)="ValidateTags($event)" (remove)="onRemove(text,$event)" placeholder="Collection Locations" (clear)="clearTags()"></ng-select> 

                    <!-- <div id="tag-list-wrapper" class="add-tag-wrapper mt-3">
                      <mat-chip-list>
                          <mat-chip *ngFor="let collectionLocationlist of collectionLocation;let i = index">{{collectionLocationlist}}
                        </mat-chip>
                      </mat-chip-list>
                    </div> -->

                    <!-- [items]="tagList" [multiple]="true" -->


                  <!-- <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Collection locations</mat-label>
                    <mat-select matInput formControlName="collectionlocations">
                      <mat-option
                        *ngFor="let collectionlocations of countryList"
                        [value]="collectionlocations.Name"
                        >{{collectionlocations.Name}}</mat-option
                      >
                    </mat-select>
                    <mat-icon matSuffix>business</mat-icon>
                    <mat-error
                      *ngIf="docForm.get('country').hasError('required')"
                    >
                      Country is required
                    </mat-error>
                  </mat-form-field> -->
                </div>
              </div>
              <div class="row">
                <div
                  class="col-xl-8 col-lg-8 col-md-6 col-sm-12 d-none d-sm-block d-md-block d-lg-block d-xl-block mb-0"
                ></div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-0">
                  <button class="btn btn-lg btn-primary w-100" type="submit">
                    Save
                  </button>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-0">
                  <button
                    class="btn btn-lg btn-secondary w-100"
                    type="button"
                    (click)="this.goBack()"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
